import CourseSearch from "./CourseSearch";
export default CourseSearch;
